export const useWoomColors = () => {
    const black = woomColors.black.DEFAULT as string;
    const white = woomColors.white.DEFAULT as string;
    const red = woomColors.red.DEFAULT as string;
    return { white, black, red };
};
